import { version as uuidVersion } from 'uuid';
import { isValidUuid } from '../isValidUuid/isValidUuid';
export const isValidV4Uuid = (uuid) => isValidUuid(uuid) && uuidVersion(uuid) === 4;
